import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {withStyles, TextField, Button, CircularProgress, Chip, Checkbox, Grid} from '@material-ui/core';
import {getProfile} from '../../../../../redux/actions/User/Profile/profileAction';
import {
    bookingFacilitySearch,
    bookingFacilitySave,
    clearBookingFacility,
} from '../../../../../redux/actions/General/BookingImport/bookingImportActions';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {Alert} from '@material-ui/lab';

const titleStyles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(titleStyles)(props => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button"/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {padding: theme.spacing(2)},
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {margin: 0, padding: theme.spacing(3, 3)},
}))(MuiDialogActions);

function BookingFacilityImport({
    onImported,
    userEmail,
    getProfile,
    bookingFacilitySearch,
    bookingFacilitySave,
    clearBookingFacility,
    facilitySearchFetching,
    facilitySearchData,
    facilitySearchError,
    facilitySaveFetching,
    facilitySaveData,
    facilitySaveError,
}) {
    const [open, setOpen] = useState(false);
    const [bookingId, setBookingId] = useState('');
    const [selected, setSelected] = useState([]);
    const [validationError, setValidationError] = useState('');

    useEffect(() => {
        if (!userEmail && typeof getProfile === 'function') {
            getProfile();
        }
    }, [userEmail, getProfile]);

    const isBusy = facilitySearchFetching || facilitySaveFetching;

    const facilities = (facilitySearchData && facilitySearchData.status === 200
        && facilitySearchData.data && Array.isArray(facilitySearchData.data.facilities))
        ? facilitySearchData.data.facilities : [];

    const importable = facilities.filter(f => f.matched && f.fact_id && !f.already_on_property);
    const existing = facilities.filter(f => f.already_on_property);
    const unmatchedCount = facilities.filter(f => !f.matched || !f.fact_id).length;

    useEffect(() => {
        if (importable.length > 0) {
            setSelected(importable.map(f => f.fact_id));
        }
    }, [facilitySearchData]);

    const reset = () => {
        setBookingId('');
        setSelected([]);
        setValidationError('');
        clearBookingFacility();
    };

    const handleOpen = () => setOpen(true);

    const handleClose = () => {
        if (isBusy) return;
        setOpen(false);
        reset();
    };

    const handleFetch = () => {
        if (!bookingId.trim()) {
            setValidationError("Lütfen geçerli bir Booking.com Hotel ID giriniz.");
            return;
        }
        setValidationError('');
        setSelected([]);
        clearBookingFacility();
        bookingFacilitySearch({hotel_id: bookingId.trim()});
    };

    const toggleFacility = (factId) => {
        setSelected(prev =>
            prev.includes(factId) ? prev.filter(p => p !== factId) : [...prev, factId]
        );
    };

    const toggleSelectAll = () => {
        if (!importable.length) return;
        if (selected.length === importable.length) {
            setSelected([]);
        } else {
            setSelected(importable.map(f => f.fact_id));
        }
    };

    const handleSave = () => {
        if (!selected.length) return;
        bookingFacilitySave({fact_ids: selected});
    };

    useEffect(() => {
        if (facilitySaveData && facilitySaveData.status === 200) {
            if (typeof onImported === 'function') {
                onImported(facilitySaveData.data);
            }
        }
    }, [facilitySaveData]);

    // const ALLOWED_EMAILS = ['cemile@extranetwork.com', 'yoy@extranetwork.com', 'cem@extranetwork.com'];
    // if (!userEmail || !ALLOWED_EMAILS.includes(userEmail.toLowerCase())) {
    //     return null;
    // }

    const searchErrorMessage = (facilitySearchData && facilitySearchData.error && facilitySearchData.message)
        || (facilitySearchError && facilitySearchError.response && facilitySearchError.response.data && facilitySearchError.response.data.message)
        || (facilitySearchError && 'Olanaklar getirilirken bir hata oluştu.');

    const saveErrorMessage = (facilitySaveData && facilitySaveData.error && facilitySaveData.message)
        || (facilitySaveError && facilitySaveError.response && facilitySaveError.response.data && facilitySaveError.response.data.message)
        || (facilitySaveError && 'Olanaklar kaydedilirken bir hata oluştu.');

    const saveSuccess = facilitySaveData && facilitySaveData.status === 200 && !facilitySaveData.error;
    const addedCount = saveSuccess && facilitySaveData.data && Array.isArray(facilitySaveData.data.added)
        ? facilitySaveData.data.added.length : 0;
    const skippedCount = saveSuccess && facilitySaveData.data && Array.isArray(facilitySaveData.data.skipped)
        ? facilitySaveData.data.skipped.length : 0;

    return (
        <>
            {/* <Button
                variant="contained"
                color="primary"
                startIcon={<CloudDownloadIcon/>}
                onClick={handleOpen}
                style={{
                    height: 36,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: 'none',
                    backgroundColor: '#003580',
                    marginTop: 12,
                }}
                className="booking-facility-import-btn"
            >
                Booking.com'dan İçe Aktar
            </Button> */}
            
            <Button
                variant="text"
                size="small"
                startIcon={<CloudDownloadIcon style={{fontSize: 16}}/>}
                onClick={handleOpen}
                style={{
                    textTransform: 'none',
                    fontWeight: 500,
                    color: '#666',
                    padding: '4px 8px',
                    fontSize: 13,
                    marginTop: 18,
                    marginLeft: -8,
                }}
                className="booking-facility-import-btn"
            >
                Booking.com'dan İçe Aktar
            </Button>

            <Dialog
                onClose={handleClose}
                open={open}
                maxWidth="md"
                fullWidth
                disableBackdropClick={true}
                disableEscapeKeyDown={isBusy}
                aria-labelledby="booking-facility-import-title"
            >
                <DialogTitle className="red-bottom-border" id="booking-facility-import-title" onClose={isBusy ? undefined : handleClose}>
                    Booking.com'dan Olanak İçe Aktar
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" style={{color: '#5b6675', marginBottom: 16}}>
                        Otelin Booking.com ID bilgisini giriniz. Eşleşen olanaklar listelenecek;
                        içe aktarmak istediklerinizi seçebilirsiniz.
                    </Typography>

                    <div style={{
                        display: 'flex',
                        gap: 12,
                        alignItems: 'flex-end',
                        flexWrap: 'wrap',
                        marginBottom: 16,
                    }}>
                        <div style={{flex: '1 1 240px', minWidth: 200}}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                label="Booking.com Hotel ID"
                                placeholder="örn: 1234567"
                                value={bookingId}
                                onChange={e => setBookingId(e.target.value)}
                                disabled={isBusy}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleFetch();
                                    }
                                }}
                            />
                        </div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleFetch}
                            disabled={isBusy || !bookingId.trim()}
                            style={{
                                height: 40,
                                minWidth: 160,
                                textTransform: 'none',
                                fontWeight: 600,
                            }}
                        >
                            {facilitySearchFetching
                                ? <CircularProgress size={20} color="inherit"/>
                                : 'Olanakları Getir'}
                        </Button>
                    </div>

                    {validationError && (
                        <Alert severity="error" style={{marginBottom: 16}}>{validationError}</Alert>
                    )}

                    {!validationError && (facilitySearchError || (facilitySearchData && facilitySearchData.error)) && (
                        <Alert severity="error" style={{marginBottom: 16}}>{searchErrorMessage}</Alert>
                    )}

                    {(facilitySaveError || (facilitySaveData && facilitySaveData.error)) && (
                        <Alert severity="error" style={{marginBottom: 16}}>{saveErrorMessage}</Alert>
                    )}

                    {saveSuccess && (
                        <Alert severity="success" style={{marginBottom: 16}}>
                            {addedCount} olanak eklendi
                            {skippedCount > 0 ? `, ${skippedCount} tanesi zaten mevcuttu.` : '.'}
                        </Alert>
                    )}

                    {facilitySearchData && facilitySearchData.status === 200 && facilities.length === 0 && (
                        <Alert severity="info" style={{marginBottom: 16}}>
                            Bu otele ait olanak bulunamadı.
                        </Alert>
                    )}

                    {facilities.length > 0 && (
                        <>
                            {unmatchedCount > 0 && (
                                <Typography variant="caption" style={{display: 'block', color: '#9ca3af', marginBottom: 8}}>
                                    {unmatchedCount} olanak sistemdeki olanaklarla eşleşmedi ve gösterilmiyor.
                                </Typography>
                            )}

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: 8,
                                        minHeight: 32,
                                    }}>
                                        <Typography variant="body2" style={{fontWeight: 600, color: '#065f46'}}>
                                            Zaten Mevcut ({existing.length})
                                        </Typography>
                                    </div>
                                    <div style={{
                                        border: '1px solid #e6e9ef',
                                        borderRadius: 8,
                                        maxHeight: 380,
                                        overflowY: 'auto',
                                        background: '#fafbfc',
                                    }}>
                                        {existing.length === 0 && (
                                            <div style={{padding: 16, textAlign: 'center', color: '#9ca3af'}}>
                                                <Typography variant="body2">Mevcut olanak yok</Typography>
                                            </div>
                                        )}
                                        {existing.map((f, i) => (
                                            <div
                                                key={`existing-${f.booking_facility_id}-${i}`}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 8,
                                                    padding: '10px 12px',
                                                    borderBottom: i < existing.length - 1 ? '1px solid #f1f3f6' : 'none',
                                                }}
                                            >
                                                <CheckCircleIcon style={{color: '#10b981', fontSize: 20}}/>
                                                <div style={{flex: 1, minWidth: 0}}>
                                                    <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'}}>
                                                        <Typography variant="body2" style={{fontWeight: 600, color: '#1f2937'}}>
                                                            {f.title}
                                                        </Typography>
                                                        {f.fact_name && (
                                                            <>
                                                                <span style={{color: '#9ca3af', fontSize: 12}}>→</span>
                                                                <Typography variant="body2" style={{color: '#5b6675'}}>
                                                                    {f.fact_name}
                                                                </Typography>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: 8,
                                        minHeight: 32,
                                        flexWrap: 'wrap',
                                        gap: 4,
                                    }}>
                                        <Typography variant="body2" style={{fontWeight: 600, color: '#003580'}}>
                                            İçe Aktarılabilir ({selected.length}/{importable.length})
                                        </Typography>
                                        <Button
                                            size="small"
                                            onClick={toggleSelectAll}
                                            disabled={isBusy || importable.length === 0}
                                            style={{textTransform: 'none', padding: '2px 8px', minWidth: 'auto'}}
                                        >
                                            {selected.length === importable.length && importable.length > 0
                                                ? 'Seçimi Temizle' : 'Tümünü Seç'}
                                        </Button>
                                    </div>
                                    <div style={{
                                        border: '1px solid #e6e9ef',
                                        borderRadius: 8,
                                        maxHeight: 380,
                                        overflowY: 'auto',
                                    }}>
                                        {importable.length === 0 && (
                                            <div style={{padding: 16, textAlign: 'center', color: '#9ca3af'}}>
                                                <Typography variant="body2">İçe aktarılabilir olanak yok</Typography>
                                            </div>
                                        )}
                                        {importable.map((f, i) => {
                                            const isSelected = selected.includes(f.fact_id);
                                            return (
                                                <div
                                                    key={`importable-${f.booking_facility_id}-${i}`}
                                                    onClick={() => !isBusy && toggleFacility(f.fact_id)}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8,
                                                        padding: '10px 12px',
                                                        borderBottom: i < importable.length - 1 ? '1px solid #f1f3f6' : 'none',
                                                        cursor: isBusy ? 'default' : 'pointer',
                                                        background: isSelected ? '#f0f5ff' : 'transparent',
                                                    }}
                                                >
                                                    <Checkbox
                                                        color="primary"
                                                        checked={isSelected}
                                                        disabled={isBusy}
                                                        onChange={() => toggleFacility(f.fact_id)}
                                                        onClick={e => e.stopPropagation()}
                                                        style={{padding: 4}}
                                                    />
                                                    <div style={{flex: 1, minWidth: 0}}>
                                                        <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'}}>
                                                            <Typography variant="body2" style={{fontWeight: 600, color: '#1f2937'}}>
                                                                {f.title}
                                                            </Typography>
                                                            {f.fact_name && (
                                                                <>
                                                                    <span style={{color: '#9ca3af', fontSize: 12}}>→</span>
                                                                    <Typography variant="body2" style={{color: '#5b6675'}}>
                                                                        {f.fact_name}
                                                                    </Typography>
                                                                </>
                                                            )}
                                                        </div>
                                                        {f.confidence > 0 && (
                                                            <div style={{marginTop: 4}}>
                                                                <Chip size="small" label={`%${f.confidence} eşleşme`}
                                                                      variant="outlined"
                                                                      style={{borderColor: '#cbd5e1', color: '#475569', height: 20}}/>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleSave}
                        disabled={selected.length === 0 || isBusy || saveSuccess}
                        variant="contained"
                        color="primary"
                        style={{textTransform: 'none', fontWeight: 600, height: 40, backgroundColor: '#003580'}}
                    >
                        {facilitySaveFetching
                            ? <CircularProgress size={20} color="inherit"/>
                            : `İçe Aktar (${selected.length})`}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const mapStateToProps = (state) => ({
    userEmail: state.profileReducer && state.profileReducer.profileData
        && state.profileReducer.profileData.profile
        && state.profileReducer.profileData.profile.email,
    facilitySearchFetching: state.bookingImportReducer && state.bookingImportReducer.facilitySearchFetching,
    facilitySearchData: state.bookingImportReducer && state.bookingImportReducer.facilitySearchData,
    facilitySearchError: state.bookingImportReducer && state.bookingImportReducer.facilitySearchError,
    facilitySaveFetching: state.bookingImportReducer && state.bookingImportReducer.facilitySaveFetching,
    facilitySaveData: state.bookingImportReducer && state.bookingImportReducer.facilitySaveData,
    facilitySaveError: state.bookingImportReducer && state.bookingImportReducer.facilitySaveError,
});

const mapDispatchToProps = {
    getProfile,
    bookingFacilitySearch,
    bookingFacilitySave,
    clearBookingFacility,
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingFacilityImport);
